import { render, staticRenderFns } from "./EditorButtons.vue?vue&type=template&id=78a4b717&scoped=true&"
import script from "./EditorButtons.vue?vue&type=script&lang=ts&"
export * from "./EditorButtons.vue?vue&type=script&lang=ts&"
import style0 from "./EditorButtons.vue?vue&type=style&index=0&id=78a4b717&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a4b717",
  null
  
)

export default component.exports